import React from "react"
import CalculatorGITabSliderStyle from "./CalculatorGITabSliderStyle.module.css"
import InputRange from "react-input-range"
import "react-input-range/lib/css/index.css"
import CalculateGiTabContent from "../calculateGITabContent/CalculateGITabContent"
import { getData } from "../../../service/CalculatorService"
import translate, { keys } from "../../../../../translation/translator"
import AnchorLink from "react-anchor-link-smooth-scroll"

class CalculatorGiTabSlider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      calculateRangeSlider: false,
      pageSize: 10,
      currentPage: 1,
      isLoading: true,
      data: [],
      value: {
        min: 5,
        max: 60,
      },
    }
  }
  componentDidMount() {
    this.getData(this.state.value.min, this.state.value.max, "gi")
  }

  handlePageChange = page => {
    this.setState({ currentPage: page })
  }

  paginationNextPage = () => {
    this.setState({ currentPage: this.state.currentPage + 1 })
  }

  paginationPrevPage = () => {
    this.setState({ currentPage: this.state.currentPage - 1 })
  }

  goToLastPage = pagesCount => {
    this.setState({ currentPage: pagesCount })
  }

  goToFirstPage = () => {
    this.setState({ currentPage: 1 })
  }

  getData = (minValue, maxValue, searchType) => {
    getData(minValue, maxValue, searchType).then(result => {
      this.setState({
        data: result.data,
        value: { min: minValue, max: maxValue },
      })
    })
  }
  handleCalculateSlider = () => {
    const { value } = this.state
    let min
    let max
    if (value.min === "") {
      this.setState({ value: { ...this.state.value, min: 5 } })
      min = 5
    } else {
      min = value.min
    }
    if (value.max === "") {
      this.setState({ value: { ...this.state.value, max: 60 } })
      max = 60
    } else {
      max = value.max
    }
    this.getData(min, max, "gi")
    this.setState({ calculateRangeSlider: true })
  }

  handleInputValueChange = event => {
    const { value } = this.state
    let min
    let max
    this.setState({
      value: {
        ...this.state.value,
        [event.target.name]: event.target.value,
      },
    })
    if (event.target.name === "min") {
      min = event.target.value
    } else {
      min = value.min
    }
    if (event.target.name === "max") {
      max = event.target.value
    } else {
      max = value.max
    }

    switch (true) {
      case max < 0:
        this.setState({
          value: { ...this.state.value, max: 0 },
        })
        break
      case max > 100:
        this.setState({
          value: { ...this.state.value, max: 100 },
        })
        break
      case min < 0:
        this.setState({
          value: { ...this.state.value, min: 0 },
        })
        break
      case Number(min) > Number(max):
        this.setState({
          value: { min: max, max: max },
        })
        break
      default:
        this.setState({
          value: {
            ...this.state.value,
            [event.target.name]: event.target.value,
          },
        })
    }
  }

  render() {
    const { calculateRangeSlider, value, currentPage, pageSize } = this.state
    const { locale } = this.props

    return (
      <React.Fragment>
        <div className={CalculatorGITabSliderStyle.slider_holder}>
          <input
            type="number"
            name="min"
            onChange={this.handleInputValueChange}
            className={CalculatorGITabSliderStyle.min_value}
            value={value.min}
          />
          <div className="gi-tab-slider-holder">
            <InputRange
              maxValue={100}
              minValue={0}
              onChange={value => this.setState({ value: value })}
              value={value}
            />
            <span className={CalculatorGITabSliderStyle.min}>0</span>
            <span className={CalculatorGITabSliderStyle.max}>100</span>
          </div>
          <input
            type="number"
            name="max"
            onChange={this.handleInputValueChange}
            className={CalculatorGITabSliderStyle.max_value}
            value={value.max}
          />
        </div>
        <p className={CalculatorGITabSliderStyle.GI_text}>
          {translate(keys.FOODS_WITH_GLYCEMIC_INDEX_BETWEEN, locale)}
        </p>
        <AnchorLink
          href="#table"
          onClick={this.handleCalculateSlider}
          className={CalculatorGITabSliderStyle.button}
        >
          {translate(keys.FOOD_SEARCH_BUTTON, locale)}
        </AnchorLink>

        <CalculateGiTabContent
          calculateRangeSlider={calculateRangeSlider}
          locale={locale}
          paginationNextPage={this.paginationNextPage}
          paginationPrevPage={this.paginationPrevPage}
          currentPage={currentPage}
          handlePageChange={this.handlePageChange}
          pageSize={pageSize}
          data={this.state.data}
          goToFirstPage={this.goToFirstPage}
          goToLastPage={this.goToLastPage}
        />
      </React.Fragment>
    )
  }
}

export default CalculatorGiTabSlider
